/**
 * @file paddle pilot hooks
 * @author wanzhongyun
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { getCmsDataInfo } from './../../api/pages/paddleCmsGetDataApi';

import {
    IPilotBanner,
    IPilotRights,
    IPilotGrowth,
    IPilotSailing,
    IPilotGroup,
    IPilotQRCode
} from './type';

const usePaddlePilotGroupHook = () => {

    const [pilotBanner, setPilotBanner] = useState<IPilotBanner>({ bannerList: [] });
    const [pilotRights, setPilotRights] = useState<IPilotRights>({ title: '', rightsList: [], joinWord: '', joinLink: ''});
    const [pilotGrowth, setPilotGrowth] = useState<IPilotGrowth>({ title: '', rightsList: [], allCourceWord: '', allCourceLink: ''});
    const [pilotSailing, setPilotSailing] = useState<IPilotSailing>({
        title: '',
        bannerList: [],
        excitingActivities: { title: '', list: [] },
        excitingProject: { title: '', list: [] }
    });
    const [pilotGroupShow, setPilotGroupShow] = useState<IPilotGroup>({
        title: '',
        cityGroup: { title: '', list: [] },
        schoolGroup: { title: '', list: [] }
    });
    const [pilotAllGroup, setPilotAllGroup] = useState<IPilotGroup>({
        title: '',
        cityGroup: { title: '', list: [] },
        schoolGroup: { title: '', list: [] }
    });

    const [pilotQRCode, setPilotQRCode] = useState<IPilotQRCode>({ qrCodeUrl: '' });

    useMount(() => {
        (async () => {
            const res = await getCmsDataInfo({requestUrl: '/paddlepilotgroup'})
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                data.banner && setPilotBanner(data.banner);
                data.personalRights && setPilotRights(data.personalRights);
                data.growthResource && setPilotGrowth(data.growthResource);
                data.startSailing && setPilotSailing(data.startSailing);
                data.groupShow && setPilotGroupShow(data.groupShow);
                data.allGroupShow && setPilotAllGroup(data.allGroupShow);
                data.qrCode && setPilotQRCode(data.qrCode);
            }
        })();
    });

    return {
        pilotBanner,
        pilotRights,
        pilotGrowth,
        pilotSailing,
        pilotGroupShow,
        pilotAllGroup,
        pilotQRCode
    }
}

export default usePaddlePilotGroupHook;